module.exports = "./img/c6576e21eb145bfba0110b5a8c008cae.jpg";